
import React, { useEffect, useState } from 'react';
import PropTypes, { bool } from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Row, Col, Table, Pagination, Button, notification } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import ModalCreatePolice from 'Pages/HomePage/ModalCreatePolice';
import ModalGenerateSolicitudExpedicion from 'Pages/HomePage/ModalGenerateSolicitudExpedicion';

import emailHooks from 'Pages/QuotationsComparatorDiff/newComponent/hooks_email';
import ModalConfirmSend from 'Components/commonComponents/modalSendEmail';
import ModalCollectEmails from 'Components/commonComponents/ModalCollectEmails';
import ModalConfirmWhatsApp from 'Components/commonComponents/modalSendWhatsApp';

import exportInBackendQuotationList from 'Api/actions/quotation/exportInBackendQuotationList';

import getTableColumns from './tableColumns';
import whatsAppHooks from './hooks_whatsap';
import { ROUTES } from '@/App/Router/routes';

const QuotationsTable = ({
  tableType,
  getPage,
  loading = false,
  items = [],
  page = 1,
  pageSize = 0,
  totalItems = 0,
  hasSolicitudesModule,
  resetResultsAllTabs,
  filtersTableQuotation,
  whatsappLogged,
}) => {
  const navigate = useNavigate();

  const [modalEmails, handleShowModalSendEmail, idQuotation] = emailHooks();
  const [modalWhatsApp, handleShowModalSendWhatsApp, quotationId] = whatsAppHooks();

  useEffect(() => {
    // Cuando cargue el componente, traerse la primera página
    getPage?.(1);
  }, []);

  // Estado que controla si los modales son visibles
  const [modalCreatePoliceState, setModalCreatePoliceState] = useState({
    visible: false,
    quotationId: null,
  });

  // Esto controla el estado del modal usado para crear las solicitudes de expedición
  const [modalGenerateSolicitudExpedicionState, setModalGenerateSolicitudExpedicionState] = useState({
    visible: false,
    quotationId: null,
  });

  const [modalExportListadoCotizaciones, setModalExportListadoCotizaciones] = useState({ visible: false });


  const tableColumns = getTableColumns(tableType, {
    hasSolicitudesModule,
    handleShowModalSendEmail,
    whatsappLogged,
    handleShowModalSendWhatsApp,
    onCrearPoliza: (quotationRowData) => {
      setModalCreatePoliceState({
        isVisible: true,
        quotationId: quotationRowData.id,
      });
    },
    onGenerateExpeditionSolicitudeishon: (quotationId) => {
      setModalGenerateSolicitudExpedicionState({
        visible: true,
        quotationId,
      });
    },
    onSeeQuotation: (quotationId) => {
      navigate(ROUTES.QUOTATIONS.PLANS.COMPARISON(quotationId));
    },
    seeEmmitedPackage: (quotationId) => {
      window.open(`${process.env.URL_SERVER_BACKEND}/quotation/render_emmitted_package/${quotationId}/?formato=pdf`, '_blank');
    },
  });

  const handdleClickExportButton = () => setModalExportListadoCotizaciones({ visible: true });
  const handdleClickCloseExportButton = () => setModalExportListadoCotizaciones({ visible: false });

  const exportQuotationList = (emails) => {
    exportInBackendQuotationList({
      filters: filtersTableQuotation,
      state: tableType,
      emails,
      // emails: emails.join(','),
      // vendedores: (filtersTableQuotation.vendedores || []).join(','),
      // aseguradoras: (filtersTableQuotation.aseguradoras || []).join(','),
    })
      .then(() => {
        setModalExportListadoCotizaciones({ visible: false })
        notification.success({
          message: `Los resultados de la exportación en momentos llegarán a ${emails.join(', ')}`,
        });
      })
      .catch((responseData) => {
        notification.error({
          message: 'No pudimos exportar el listado de cotizaciones',
          description: responseData.message,
        });
      })
  };

  return (
    <>
      <div style={{ position: 'absolute', top: -53, right: 2}}>
        {['DONE', 'SLOPE_EMIT'].includes(tableType) && (
          <Button type="primary" onClick={handdleClickExportButton}>
            <FontAwesomeIcon icon={faFileExcel} style={{ color: '#fff' }} />
            &nbsp;Exportar
          </Button>
        )}
      </div>
      <Row>
        <Col span={24} style={{ overflowY: 'hidden' }}>
          <Table
            rowKey='id'
            dataSource={items}
            columns={tableColumns}
            bordered={true}
            loading={{
              spinning: loading,
              tip: 'Cargando cotizaciones...'
            }}
            pagination={false}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ display: 'flex', justifyContent: 'center', padding: '12px' }}>
          <Pagination
            disabled={loading}
            current={page}
            total={totalItems}
            pageSize={pageSize}
            onChange={(newPage) => getPage?.(newPage)}
            showSizeChanger={false}
          />
        </Col>
      </Row>
      <ModalConfirmSend
        visible={modalEmails.isVisible}
        handleCancel={modalEmails.handleCancel}
        title="Enviar Cotización"
        label="Ingresa los E-mails a los que deseas enviar la cotización"
        placeholder="E-mails"
        idQuotation={idQuotation}
      />
      <ModalConfirmWhatsApp
        visible={modalWhatsApp.isVisible}
        handleCancel={modalWhatsApp.handleCancel}
        title="Enviar Cotización"
        label="Ingresa los Telefonos a los que deseas enviar la cotización"
        placeholder="+573xxxxxxxxx,(+57)3xxxxxxxxx,3xxxxxxxxx,..."
        idQuotation={quotationId}
      />
      {(tableType === 'DONE' && modalCreatePoliceState.quotationId) && (
        <ModalCreatePolice
          isVisible={modalCreatePoliceState.isVisible}
          quotationId={modalCreatePoliceState.quotationId}
          onCloseModal={() => setModalCreatePoliceState({ visible: false, quotationId: null })}
          onSuccess={() => {
            setModalCreatePoliceState({ visible: false, quotationId: null })
            resetResultsAllTabs?.();
          }}
        />
      )}
      {(tableType === 'DONE' && modalGenerateSolicitudExpedicionState.quotationId) && (
        <ModalGenerateSolicitudExpedicion
          visible={modalGenerateSolicitudExpedicionState.visible}
          quotationId={modalGenerateSolicitudExpedicionState.quotationId}
          onCloseModal={() => setModalGenerateSolicitudExpedicionState({ visible: false, quotationId: null })}
          onSuccess={(numSolicitud) => {
            setModalGenerateSolicitudExpedicionState({ visible: false, quotationId: null });
            resetResultsAllTabs?.();
            var url = `${process.env.URL_SOFTSEGUROS}`;
            if (url[url.length-1] === '/') {
              url = url.substring(0, url.length-1);
            }
            window.open(`${url}/home/#solicitudes/${numSolicitud}/documentacion/`);
          }}
        />
      )}

      {['DONE', 'SLOPE_EMIT'].includes(tableType) && (
        <ModalCollectEmails
          modalTitle="Exportar listado cotizaciones"
          modalIsVisible={modalExportListadoCotizaciones.visible}
          handdleSendModal={exportQuotationList}
          handdleCancelModal={handdleClickCloseExportButton}
          successButtonText="Exportar"
          cancelButtonText="Cancelar"
        />
      )}
    </>
  );
};

QuotationsTable.propTypes = {
  tableType: PropTypes.string.isRequired,
  getPage: PropTypes.func,
  loading: PropTypes.bool,
  items: PropTypes.array,
  page: PropTypes.any,
  pageSize: PropTypes.any,
  totalItems: PropTypes.any,
  hasSolicitudesModule: bool.isRequired,
  resetResultsAllTabs: PropTypes.func,
  filtersTableQuotation: PropTypes.shape({}).isRequired,
  whatsappLogged: bool.isRequired,
};

const mapStateToProps = (state) => ({
  hasSolicitudesModule: state.initialData.has_solicitudes_module,
  whatsappLogged: state.initialData.whatsapp_is_logged,
  filtersTableQuotation: state.tableQuotations.filtersTableQuotations,
});

export default connect(mapStateToProps, {})(QuotationsTable);
